import React from 'react'
import styled from 'styled-components'
import Select from 'react-select'
import { Link, withRouter } from 'react-router-dom'

const customColors = {
  black: '#000',
  white: '#fff',
  freshGreen: '#0BAC5D',
}

export const Container = styled.div`
  /* margin-top: 40px; */

  @media screen and (max-width: 600px) {
    margin-top: 0px;
  }
`

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  ${(props) => props.gap && `gap: ${props.gap}`};
  /* flex-wrap: wrap; */

  > div {
    width: 50%;
  }

  @media only screen and (max-width: 980px) {
    flex-wrap: wrap;

    > div {
      width: 100%;
    }
  }

  @media only screen and (max-width: 980px) {
    gap: ${(props) => (props.gapSm ? props.gapSm : '0')};
    ${(props) => props.reverse && 'flex-direction: column-reverse;'}
    flex-wrap: wrap;
    > div {
      width: 100%;
    }
  }

  @media only screen and (max-width: 600px) {
    gap: ${(props) => (props.gapSm ? props.gapSm : '0')};
    ${(props) => props.reverse && 'flex-direction: column-reverse;'}
    flex-wrap: wrap;
    > div {
      width: 100%;
    }
  }
`

export const ContainerFlexRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${(props) => (props.gap ? props.gap : '0px')};
  padding: ${(props) => (props.padding ? props.padding : '0px')};

  ${(props) => props.gray && 'background-color: #F8F9F9'};
  ${(props) => props.background && `background-color: ${props.background}`};

  ${(props) => props.center && 'justify-content: center'};

  ${(props) =>
    props.spaceBetween &&
    'width: -webkit-fill-available; justify-content: space-between'};

  ${(props) => props.dark && 'background-color: #154549'};

  @media screen and (max-width: 1025px) {
    flex-direction: ${(props) =>
      props.columnReverse ? 'column-reverse' : 'column'};
    ${(props) => props.rowMd && 'flex-direction: row'};
    ${(props) => props.gapMd && `gap: ${props.gapMd}`};
    ${(props) => props.paddingMd && `padding: ${props.paddingMd}`};
  }

  @media only screen and (max-width: 600px) {
    gap: ${(props) => (props.gapSm ? props.gapSm : '30px')};
    flex-direction: ${(props) =>
      props.columnReverse ? 'column-reverse' : 'column'};
    ${(props) => props.paddingSm && `padding: ${props.paddingSm}`};
  }
`

export const ContainerFlex = styled.div`
  max-width: 100vw;
  display: flex;
  flex-direction: row;
  gap: ${(props) => (props.gap ? props.gap : '0px')};
  padding: ${(props) => (props.padding ? props.padding : '0px')};
  ${(props) => props.background && `background-color: ${props.background}`};
  ${(props) => props.center && 'justify-content: center'};
  ${(props) =>
    props.spaceBetween &&
    'width: -webkit-fill-available; justify-content: space-between'};

  @media screen and (max-width: 1025px) {
    ${(props) => props.gapMd && `gap: ${props.gapMd}`};
    ${(props) => props.paddingMd && `padding: ${props.paddingMd}`};
  }

  @media screen and (max-width: 768px) {
    gap: ${(props) => (props.gapSm ? props.gapSm : '30px')};
    flex-direction: ${(props) =>
      props.columnReverse ? 'column-reverse' : 'column'};
    ${(props) => props.paddingSm && `padding: ${props.paddingSm}`};
  }
`

export const SmallRow = styled.div`
  display: flex;
  flex-direction: row;
  ${(props) =>
    props.spaceBetween &&
    'width: -webkit-fill-available; justify-content: space-between'};
  ${(props) => props.gap && `gap: ${props.gap}`};
`

export const ContainerFlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

  ${(props) => props.padding && `padding: ${props.padding}`};
  ${(props) => props.center && 'justify-content: center; align-items: center'};
  ${(props) => props.background && `background-color: ${props.background}`};

  @media screen and (max-width: 768px) {
    ${(props) => props.paddingSm && `padding: ${props.paddingSm}`};
  }
`

export const ContainerFlexColumnStart = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: ${(props) => (props.center ? 'center' : 'flex-start')};
  align-items: flex-start;
  gap: ${(props) => (props.gap ? props.gap : '0px')};
  ${(props) => props.padding && `padding: ${props.padding}`};
  ${(props) => props.background && `background-color: ${props.background}`};
  ${(props) => props.width && `width: ${props.width}`};

  @media screen and (max-width: 1025px) {
    ${(props) => props.gapMd && `gap: ${props.gapMd}`};
    ${(props) => props.paddingMd && `padding: ${props.paddingMd}`};
    ${(props) => props.widthMd && `width: ${props.widthMd}`};
  }

  @media screen and (max-width: 768px) {
    ${(props) => props.gapSm && `gap: ${props.gapSm}`};
    ${(props) => props.paddingSm && `padding: ${props.paddingSm}`};
    flex-direction: ${(props) =>
      props.columnReverse ? 'column-reverse' : 'column'};
  }
`

export const BrushStoke = styled.div`
  background-image: url('/images/homepage/brush.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 20px 20px 20px 40px;
  position: relative;
  left: -40px;
  width: 100%;

  @media screen and (max-width: 768px) {
    position: static;
    padding: 5px 8px;
  }
`

export const Title = styled.h1`
  color: ${(props) => (props.white ? '#fff' : '#000')};
  ${(props) => props.color && `color: ${props.color}`};
  font-family: 'Open Sans', sans-serif !important;
  font-size: ${(props) => (props.size ? props.size : '50px')};
  font-style: normal;
  font-weight: ${(props) => (props.weight ? props.weight : '700')};
  line-height: ${(props) => (props.lineheight ? props.lineheight : '140%')};

  ${(props) => props.center && 'text-align: center'};
  ${(props) => props.margin && `margin: ${props.margin}`};

  ${(props) => props.width && `width: ${props.width}`};
  b {
    font-weight: 700;
    color: #0bac5d;
  }

  @media screen and (max-width: 1025px) {
    font-size: ${(props) => (props.sizemd ? props.sizemd : '50px')};
    ${(props) => props.marginmd && `margin: ${props.marginmd}`};
    ${(props) => props.widthMd && `width: ${props.widthMd}`};
    ${(props) => props.centerMd && 'text-align: center'};
  }

  @media screen and (max-width: 767px) {
    font-size: ${(props) => (props.sizesm ? props.sizesm : '42px')};
    ${(props) => props.marginsm && `margin: ${props.marginsm}`};
    ${(props) => props.smCenter && 'text-align: center; width: 100%;'}
    ${(props) => props.width && `width: 100%`};
    ${(props) => props.paddingSm && `padding: ${props.paddingSm}`};
  }
`

export const Green = styled.span`
  color: #0bac5d;
`

export const Subtitle = styled.h2`
  color: ${(props) => (props.white ? '#fff' : '#000')};
  ${(props) => props.color && `color: ${props.color}`};
  /* font-family: "Source Sans Pro", sans-serif ; */
  font-family: ${(props) =>
    props.bold
      ? `"Source Sans Pro Semibold", sans-serif`
      : `"Source Sans Pro", sans-serif`};
  font-size: ${(props) => (props.size ? props.size : '20px')};
  /*font-weight: ${(props) => (props.bold ? 'bold' : '400')};*/
  font-weight: ${(props) => (props.weight ? props.weight : '700')};
  line-height: 146%;
  ${(props) => props.width && `width: ${props.width}`};
  ${(props) => props.center && 'text-align: center'};
  ${(props) => props.margin && `margin: ${props.margin}`};

  @media screen and (max-width: 1025px) {
    ${(props) => props.sizemd && `font-size: ${props.sizemd}`};
    ${(props) => props.marginmd && `margin: ${props.marginmd}`};
  }

  @media screen and (max-width: 767px) {
    ${(props) =>
      props.sizesm ? `font-size: ${props.sizesm}` : 'font-size: 18px'};
    ${(props) => props.marginsm && `margin: ${props.marginsm}`};
    ${(props) => props.smCenter && 'text-align: center'}
    ${(props) => props.width && `width: 100%`};
  }

  a {
    text-decoration: none;
    font-weight: ${(props) => (props.bold ? 'bold' : '400')};
    color: #000;

    &:hover {
      color: ${customColors.freshGreen};
    }
  }
`

export const SubtitleOpen = styled.h2`
  color: ${(props) => (props.white ? '#fff' : '#000')};
  ${(props) => props.color && `color: ${props.color}`};
  /* font-family: "Open Sans", sans-serif ; */
  font-family: ${(props) =>
    props.bold
      ? `"Open Sans Semibold", sans-serif`
      : `"Open Sans", sans-serif`};
  font-size: ${(props) => (props.size ? props.size : '20px')};
  /*font-weight: ${(props) => (props.bold ? 'bold' : '400')};*/
  font-weight: ${(props) => (props.weight ? props.weight : '700')};
  line-height: 146%;
  ${(props) => props.width && `width: ${props.width}`};
  ${(props) => props.center && 'text-align: center'};
  ${(props) => props.margin && `margin: ${props.margin}`};

  @media screen and (max-width: 1025px) {
    ${(props) => props.sizemd && `font-size: ${props.sizemd}`};
    ${(props) => props.marginmd && `margin: ${props.marginmd}`};
  }

  @media screen and (max-width: 767px) {
    ${(props) =>
      props.sizesm ? `font-size: ${props.sizesm}` : 'font-size: 18px'};
    ${(props) => props.marginsm && `margin: ${props.marginsm}`};
    ${(props) => props.smCenter && 'text-align: center'}
    ${(props) => props.width && `width: 100%`};
  }

  a {
    text-decoration: none;
    font-weight: ${(props) => (props.bold ? 'bold' : '400')};
    color: #000;

    &:hover {
      color: ${customColors.freshGreen};
    }
  }
`

export const CustomSubtitle = styled(Subtitle)`
  ${(props) => props.mediumBold && 'font-weight: 600'};
  b {
    font-weight: 700;
    font-family: 'Source Sans Pro Semibold', sans-serif;
    b {
      font-weight: 700;
      color: ${customColors.freshGreen};
    }
  }

  a {
    color: ${customColors.freshGreen};
    text-decoration: none;
    font-weight: 700;
  }
`

export const HelpText = styled(Subtitle)`
  color: ${(props) => (props.color ? props.color : '#717171')};
  font-style: italic;
  font-weight: 400;
  line-height: 127%; /* 20.32px */
  letter-spacing: -0.16px;
  display: flex;
  align-items: flex-start;
  &::before {
    @media screen and (min-width: 430px) {
      content: url('/images/icons/help.svg');
      margin-right: 10px;
    }
  }
`

export const GreenBoldSub = styled(Subtitle)`
  b {
    color: #0bac5d;
  }
`

export const LinkText = styled.a`
  color: #0bac5d;
  font-size: ${(props) => (props.size ? props.size : '16px')};
  font-weight: ${(props) => (props.weight ? props.weight : 'bold')};
  text-decoration: none;
  ${(props) => props.margin && `margin: ${props.margin}`};

  a {
    color: #0bac5d;
    font-size: ${(props) => (props.size ? props.size : '16px')};
    font-weight: ${(props) => (props.weight ? props.weight : 'bold')};
    text-decoration: none;
  }

  &:after {
    content: '>';
    font-style: normal;
    font-weight: bold;
    font-family: 'Source Sans Pro', sans-serif !important;
    text-decoration: inherit;
    padding-left: 5px;
    color: #0bac5d;
  }
`

export const Paragraph = styled.p`
  color: ${(props) => (props.white ? '#fff' : '#000')};
  font-family: 'Source Sans Pro', sans-serif !important;
  font-size: ${(props) => (props.size ? props.size : '18px')};
  font-weight: ${(props) => (props.bold ? 'bold' : '400')};
  line-height: 146%;
  ${(props) => props.width && `width: ${props.width}`};
  ${(props) => props.center && 'text-align: center'};
  ${(props) => props.margin && `margin: ${props.margin}`};
  ${(props) => props.color && `color: ${props.color}`};
`

export const CustomTypography = styled.h2`
  color: #000;
  text-align: center;
  font-family: 'Source Sans Pro', sans-serif !important;
  font-size: 22px;
  font-weight: 400;
  line-height: 157%; /* 34.54px */
  letter-spacing: 8.14px;
  text-align: left;
  ${(props) => props.margin && `margin: ${props.margin}`};

  @media screen and (max-width: 1025px) {
    ${(props) => props.marginmd && `margin: ${props.marginmd}`};
  }

  @media screen and (max-width: 768px) {
    ${(props) => props.marginsm && `margin: ${props.marginsm}`};
    ${(props) => props.smCenter && 'text-align: center'}
  }
`

export const BackOutline = styled.button`
  border-radius: 5px;
  background: #fff;
  color: #000;
  font-family: 'Source Sans Pro', sans-serif !important;

  border: 1px solid #000;
  padding: ${(props) => (props.padding ? props.padding : '14px 20px')};

  display: flex;
  align-items: center;
  gap: 14px;

  &::before {
    content: url('/images/icons/back-green.svg');
    height: 20px;
  }

  a {
    display: inline-block;
    color: #000;
    text-decoration: none;
    vertical-align: middle;
    width: 100%;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 170%;
  }

  @media screen and (max-width: 768px) {
    padding: 5px 14px;
  }
`

export const CustomLink = styled(Link)`
  text-decoration: none;
`

export const Button = styled.button`
  border-radius: 5px;
  background: ${(props) => (props.background ? props.background : '#0BAC5D')};
  color: #fff;
  font-family: 'Source Sans Pro', sans-serif !important;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 170%;
  border: none;

  /*
    commented out by PJ : 
    padding: ${(props) => (props.wider ? '11px 50px' : '11px 25px')};
    a {
        text-decoration: none;
        color: #fff;
    }
    */

  padding: 0;

  a {
    display: inline-block;
    color: #fff;
    text-decoration: none;
    height: 50px;
    vertical-align: middle;
    width: 100%;
    padding: ${(props) => (props.wider ? '9px 50px' : '9px 25px')};
  }

  @media screen and (max-width: 768px) {
    ${(props) => !props.noFill && `width: -webkit-fill-available;`};
  }
`

export const ActionButtons = styled(Button)`
  ${(props) => props.margin && `margin: ${props.margin}`};
  ${(props) => props.blackText && `color: #000;`};
  ${(props) => props.color && `color: ${props.color};`};
  ${(props) => props.border && `border: 1px solid ${props.border};`};

  padding: ${(props) => (props.padding ? props.padding : '15px 35px')};

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;

  @media screen and (max-width: 400px) {
    ${(props) => props.fontsizesm && `font-size: ${props.fontsizesm}`};
  }
`

export const LoadingButton = styled(ActionButtons)`
  &::before {
    content: url('/images/icons/load.svg');
    height: 22px;
    border-radius: 50%;
    animation-name: spin;
    animation-duration: 1500ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`

export const PrimaryButton = styled.button`
  background-color: #eb5e55;
  border-radius: 5px;
  min-width: 233px;
  border: none;
  padding: 18px 26px;

  @media screen and (max-width: 1024px) {
    min-width: 180px;
    padding: 12px 22px;
  }

  @media screen and (max-width: 600px) {
    min-width: 180px;
    padding: 16px 22px;
  }

  ${(props) => props.margin && `margin: ${props.margin}`};

  a {
    color: #fff !important;
    height: unset;
    font-family: 'Source Sans Pro';
    font-size: calc(18px + (22 - 18) * ((100vw - 360px) / (1440 - 360)));
    font-style: normal;
    vertical-align: unset;
    font-weight: 600;
    line-height: normal;
    text-decoration: none;
    padding: 0;
  }
`

export const PrimaryOutlineButton = styled(PrimaryButton)`
  background-color: transparent;
  border: 2px solid #eb5e55;

  a {
    color: #eb5e55 !important;
  }
`

export const Input = styled.input`
  padding: 13px 16px;
  width: -webkit-fill-available;
  margin: ${(props) => (props.margin ? props.margin : '0 0 30px 0')};

  border-radius: 4px;
  border: 1px solid rgba(17, 17, 19, 0.39);

  color: rgba(0, 0, 0, 0.6);
  font-family: 'Source Sans Pro', sans-serif !important;
  font-size: ${(props) => (props.size ? props.size : '16px')};
  font-style: normal;
  font-weight: 400;
  line-height: 127%; /* 20.32px */
  letter-spacing: -0.16px;

  &.error-border {
    border: 3px solid red;
  }

  @media screen and (max-width: 600px) {
    margin: ${(props) => (props.marginsm ? props.marginsm : '0 0 30px 0')};
  }
`

export const FormInput = styled(Input)`
  border: 1px solid lightgray;
`

export const CustomButton = styled(Button)`
  ${(props) => props.margin && `margin: ${props.margin}`};

  a {
    height: auto;
    font-weight: normal;
  }
`

export const OutlineButton = styled(CustomButton)`
  max-width: fit-content;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 0;
  height: fit-content;
  margin: auto 0;
  border: 1px solid #154549;
  background-color: transparent;
  a {
    padding: 9px 16px;
    white-space: nowrap;
    color: #154549;
    background-color: transparent;
  }
`

export const Image = styled.div`
  ${(props) => (props.fitImage ? 'height: inherit;' : 'height: 100%;')};
  border-radius: ${(props) => (props.square ? '0px' : '15px')};
  text-align: center;
  ${(props) => props.background && 'background-color: #16494D'};

  img {
    width: ${(props) => (props.width ? props.width : '100%')};
    border-radius: ${(props) => (props.square ? '0px' : '15px')};
    ${(props) => props.fitImage && 'object-fit: cover; height: 100%;'}
  }

  @media screen and (max-width: 1025px) {
    img {
      width: ${(props) => (props.widthMd ? props.widthMd : '100%')};
    }
  }

  @media screen and (max-width: 768px) {
    img {
      width: 100%;
    }
  }
`

export const Logos = styled.div`
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5vh 0;
  ${(props) => props.padding && `padding: ${props.padding}`};

  @media screen and (max-width: 1025px) {
    ${(props) => props.paddingMd && `padding: ${props.paddingMd}`};
  }

  @media screen and (max-width: 768px) {
    ${(props) => props.paddingSm && `padding: ${props.paddingSm}`};
  }
`

export const FlexCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) =>
    props.background ? `${props.background}` : '#fff'};
  ${(props) => props.margin && `margin: ${props.margin}`};
  ${(props) => props.padding && `padding: ${props.padding}`};

  @media only screen and (max-width: 600px) {
    ${(props) => props.paddingSm && `padding: ${props.paddingSm}`};
  }
`

export const BlueSection = styled.div`
  display: flex;
  height: ${(props) => (props.height ? props.height : '100%')};
  margin: 5vh 0;
  flex-direction: column;
  background-color: ${(props) => (props.beige ? '#F2E8D8' : '#E1F5F6')};
  width: 80%;
  justify-content: center;
  align-items: center;
  gap: 40px;
  ${(props) => props.padding && `padding: ${props.padding}`};

  /* h2 {
        text-align: center;
    } */

  @media screen and (max-width: 768px) {
    width: 90%;
    height: auto;
    padding: ${(props) => (props.paddingSm ? props.paddingSm : '70px 15px')};
  }
`

export const Testimonails = styled.div`
  background: #f2e8d8 url(${(props) => props.image}) bottom left no-repeat;
  background-size: 100%;
  background-position-y: 105%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  padding: 75px 0 120px 0;

  overflow: hidden;

  & h1 {
    margin-bottom: 40px;
  }

  @media screen and (max-width: 768px) {
    background-size: 300%;
  }
`

export const HelpContainer = styled.div`
  display: flex;
  width: 35vw;
  justify-content: space-between;
  align-items: center;
  padding: 18px;
  border-radius: 7px;
  background: #235054;
  margin-top: 18px;

  h2 {
    text-decoration: none;
    color: #fff;
  }

  & img {
    width: 5px;
    height: 11px;
    rotate: 180deg;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
  }
`

export const LinkContainer = styled.div`
  width: -webkit-fill-available;
  a {
    text-decoration: none;
    color: #fff;
  }

  img {
    margin-left: 5px;
  }
`

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 50px 20px;
  background-color: #e1f5f7;

  & button {
    width: 20vw;
    margin-left: 10px;

    @media screen and (max-width: 768px) {
      width: -webkit-fill-available;
      margin-left: 0;
    }
  }
`

export const SelectStyled = styled(Select)`
  width: 40vw;

  & > div:first-of-type {
    height: 55px;
  }

  @media screen and (max-width: 768px) {
    width: 90vw;
  }
`

export const CustomSelect = styled(Select)`
  width: ${(props) => (props.width ? props.width : '40vw')};
  ${(props) => props.height && `height: ${props.height}`};
  font-size: ${(props) => (props.size ? props.size : '16px')};

  & > div:first-of-type {
    border-radius: 4px;
    border: 1px solid rgba(17, 17, 19, 0.39);
    & > div:first-of-type {
      padding: 8px 16px;
    }
  }

  margin: ${(props) => (props.margin ? props.margin : '0 0 30px 0')};

  &.error-border {
    border-radius: 8px;
    border: 3px solid red;
  }

  @media screen and (max-width: 768px) {
    width: -webkit-fill-available;
  }

  @media screen and (max-width: 600px) {
    margin: ${(props) => (props.marginsm ? props.marginsm : '0 0 30px 0')};
  }
`

export const FormSelect = styled(CustomSelect)`
  & > div:first-of-type {
    height: ${(props) => (props.height ? props.height : '58px')};
    border-radius: 4px;
    border: 1px solid lightgray;
  }
`

export const CheckboxWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 20px;
  align-items: center;

  label {
    font-family: 'Source Sans Pro', sans-serif !important;
    font-size: 19px;
    font-style: ${(props) => (props.checked ? 'bold' : 'normal')};
    line-height: 170%;
    color: ${(props) => (props.checked ? '#4CAF50' : '#7C7C7C')};
    margin-bottom: 0;

    @media screen and (max-width: 768px) {
      font-size: 16px;
      margin-bottom: 0;
      width: 72vw;
    }
  }

  @media screen and (max-width: 768px) {
    margin-top: 0;
  }
`

export const CheckboxInput = styled.input`
  display: none;
`

export const CustomCheckbox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 34px;
  height: 34px;
  background-color: #fff;
  border-radius: 50%;
  border: 3px solid ${(props) => (props.checked ? '#4CAF50' : '#7C7C7C')};
  transition: background-color 0.2s;

  img {
    width: 18px;
  }
  @media screen and (max-width: 768px) {
    /* width: 40px; */
  }
`

export const FreebirdSection = styled.div`
  margin-bottom: 25px;
  max-width: 230px;
  @media screen and (max-width: 768px) {
    img {
      margin-bottom: 25px;
    }
  }
`

export const YouTube = styled.iframe`
  height: 100%;
  width: 100%;
`

export const CommunityFrame = styled.iframe`
  height: 2000px;
  width: 100%;
`

export const LineBreak = styled.div`
  height: 15px;
  background-color: #fff;
`

export const AwardSection = styled.div`
  width: 80%;

  @media screen and (max-width: 768px) {
    width: 100%;
    h1,
    h2 {
      text-align: center;
    }
  }
`

export const AwardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  /* & > div {
        width: 80%;

        @media screen and (max-width: 768px) {
            width: 100%;
        }
    } */

  & > div {
    height: 200px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    @media screen and (max-width: 1025px) {
      width: 100%;
    }
  }

  h2 {
    text-align: center;
  }

  img {
    width: 100%;
    max-height: 190px;
  }
`

export const TextArea = styled.textarea`
  ${(props) => props.margin && `margin: ${props.margin}`};
  min-width: 100%;
  border: 1px solid lightgray;
  border-radius: 5px;
  padding: 13px;
`

export const CheckboxDiv = styled.div`
  display: flex;
  align-items: center;
  padding: 13px 16px;
  border-radius: 4px;
  border: 2px solid rgba(17, 17, 19, 0.2);
  background: #fff;

  &:not(:last-child) {
    margin-bottom: 20px;
  }

  width: 40vw;

  @media screen and (max-width: 768px) {
    width: 100%;
  }

  h2 {
    width: 100%;
    white-space: nowrap;
  }

  &.error-border {
    border: 3px solid red;
  }

  &.checked {
    background: #e2f4e6;

    &::after {
      content: url('/images/new-profile/check-small.svg');
      width: -webkit-fill-available;
      text-align: end;
    }
  }
`

export const Checkbox = styled.input`
  content: url('/images/icons/radio-not-check.svg');
  margin-right: 10px;
  height: 18px;
  min-width: 18px;
  display: block;
  overflow: hidden;

  &.checked {
    content: url('/images/icons/radio-check.svg');
    margin-right: 10px;
    height: 18px;
    display: block;
    overflow: hidden;
  }
`

export const CustomAccordionDiv = styled.div`
  .Mui-expanded {
    img {
      transform: rotate(136deg);
    }
  }

  .MuiAccordionSummary-root {
    border-bottom: 1px solid ${customColors.black};
    padding-left: 5px;
    padding-right: 23px;

    &.Mui-expanded {
      min-height: unset;
    }
  }

  .MuiAccordionSummary-content {
    margin: 20px 0;

    /* .Mui-expanded {
            margin: 12px 0;
        } */
  }

  .MuiAccordionDetails-root {
    margin-bottom: 15px;
    padding: 8px 16px 16px 5px;
  }

  .MuiPaper-elevation1 {
    box-shadow: none;
  }
`
